import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import { AddButton, DeleteButton } from "../../utils/commonComponent/Custom/Button";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { useLocation, useNavigate } from "react-router-dom";
import { getPermissions } from "../rbac/hasAccess";
import { toast } from "react-toastify";
import { fetchSettings } from "./fetchHandler";

const headers = [
  "id",
  "jobNumber",
  "jobDate",
  "labReferenceNo",
  "customerName",
  "inwardDate",
  "contactPerson",
  "Created_By"
];

const fields = [
  { value: "jobNumber", label: "Job Number" },
  { value: "labReferenceNo", label: "Lab Reference No" },
  { value: "customerName", label: "Customer Name" },
];

const InwardList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editInward/${row.inward_id}`);

  const [searchBy, setSearchBy] = useState(sessionStorage.getItem("searchBy") || "labReferenceNo");
  const [searchKey, setSearchKey] = useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = useState(sessionStorage.getItem("searched") === "true" || false);
  const [inwardList, setInwardList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [settingList, setSettingList] = React.useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  // Menu
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  
  // local storage data
  const _userType = Number(localStorage.getItem("type"));
  const _userId = Number(localStorage.getItem("id"));

  const handleMenuOpen = (e, row) => {
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const getQuery = (count = false) => {
    const colMap = {
      jobNumber: "j.jobNumber",
      labReferenceNo: "i.labReferenceNo",
      customerName: "i.customerName",
    };
    const colName = colMap[searchBy];
    const key = searchKey.trim();
    
    let whereConditions = "where i.status = 1"
    let pagination_settings = "";
    
    
    if (colName && key) {
      whereConditions +=  ` AND LOWER(${searchBy}) LIKE LOWER('%${searchKey}%')`;
    }
    
    // If user type is 1,2(admin, superadmin) otherwise show records created by that user 
    // if (![1, 2, 12].includes(_userType)) {
    //   whereConditions += ` AND i.createdBy = ${_userId}`;
    // }

    if (count) {
      return `SELECT COUNT(*) AS no_of_rows FROM inward i LEFT JOIN jobRegister j ON i.jobId = j.id LEFT JOIN clientMaster c ON i.customerName = c.id ${whereConditions};`;
    }

    // Add pagination to query
    const offset = currentPage * rowsPerPage;
    pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${offset}`;

    return `SELECT i.id AS inward_id, i.jobId, i.customerName AS customer_id, i.contactPerson AS inward_contactPerson, c.companyName AS customer_name, c.contact AS client_contact, c.uniCode AS client_uniCode, i.inwardDate, i.contactPerson, i.location, i.labReferenceNo, i.createdBy, i.sampleDetails, e.name AS Created_By, i.approvedBy, i.status, i.disciplineId, i.groupId, j.department AS jobDept, j.projectName AS jobProjectName, j.reference AS jobReference, j.jobNumber, j.jobDate FROM inward i LEFT JOIN jobRegister j ON i.jobId = j.id LEFT JOIN userMaster u ON i.createdBy = u.id LEFT JOIN employees e ON u.employeeId = e.id LEFT JOIN clientMaster c ON i.customerName = c.id ${whereConditions} ORDER BY inward_id DESC ${pagination_settings};`;
  };

  const fetchData = async () => {
    try {
      const countQuery = getQuery(true);
      const countResult = await fetchQuery(countQuery);
      setTotalRecords(countResult[0]?.no_of_rows || 0);

      const conditionQuery = getQuery();
      const testData = await fetchQuery(conditionQuery);
      let modifiedData = testData?.map((item) => ({
        ...item,
        customerName: item.customer_id,
      }));
      setInwardList(modifiedData);
    } catch (error) {
      console.error("Error fetching inward data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }

    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
    fetchSettings(setSettingList);
  }, []);

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("labReferenceNo");
    setSearchKey("");
    // Clear all inward list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === inwardList.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(inwardList.map((r) => r.inward_id));
    }
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this?");
    if (!confirmed) return;

    try {
      const idArray = Array.isArray(id) ? id : [id];
      const idString = idArray.join(",");

      // Soft delete inward
      await fetchQuery(`UPDATE inward SET status = -1 WHERE id IN (${idString})`);

      // Soft delete inwardTests using inwardId
      await fetchQuery(`UPDATE inwardTests SET status = -1 WHERE inwardId IN (${idString})`);

      // Soft delete observationSheet using inwardId
      await fetchQuery(`UPDATE observationSheet SET status = -1 WHERE inwardId IN (${idString})`);

      // Soft delete certificate using inwardId
      await fetchQuery(`UPDATE certificate SET status = -1 WHERE inwardId IN (${idString})`);

      toast("Deleted Successfully!");
      setTimeout(() => window.location.reload(false), 1000);

    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/editInward/0"
          label="Add Inward"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Inward"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      {selectedIds.length > 0 &&
        (permissions.delete || permissions.allAccess) && (
          <div className="shadow-sm p-2 pt-1 mb-2 bg-white">
            <DeleteButton
              id="btn-multi-delete"
              label="Multiple Delete"
              onClick={() => handleDelete(selectedIds)}
            />
          </div>
        )}

      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                <th className="px-2 py-3 text-center">
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={
                      selectedIds.length === inwardList.length &&
                      inwardList.length > 0
                    }
                  />
                </th>
                {headers.map((header, i) => (
                  <th
                    key={i}
                    className="px-4 py-3 text-center whitespace-nowrap capitalize"
                  >
                    {header === "id"
                      ? "Sr. No."
                      : header.replace(/([A-Z])/g, " $1")}
                  </th>
                ))}
                <th className="px-4 py-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {inwardList.map((row, index) => (
                <tr key={row.inward_id} className="hover:bg-gray-50">
                  <td className="px-2 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(row.inward_id)}
                      onChange={() => handleSelectRow(row.inward_id)}
                    />
                  </td>
                  <td className="text-center px-4 py-2">{currentPage * rowsPerPage + index + 1}</td>
                  <td className="text-center px-4 py-2">{row.jobNumber}</td>
                  <td className="text-center px-4 py-2">{row.jobDate ? moment(row.jobDate).format("DD-MM-YYYY") : "-"}</td>
                  <td className="text-center px-4 py-2">{row.labReferenceNo}</td>
                  <td className="text-center px-4 py-2 truncate-text">{row.customerName}</td>
                  <td className="text-center px-4 py-2">{row.inwardDate ? moment(row.inwardDate).format("DD-MM-YYYY") : "-"}</td>
                  <td className="text-center px-4 py-2">{row.contactPerson}</td>
                  <td className="text-center px-4 py-2">{row.Created_By}</td>
                  <td className="text-center px-4 py-2">
                    <div className="flex items-center justify-center gap-2">
                      {(permissions.edit || permissions.allAccess) && (
                        <button
                          onClick={() => handleEdit(row)}
                          className="text-blue-600 hover:text-blue-800"
                        >
                          <EditIcon fontSize="small" />
                        </button>
                      )}
                      {(permissions.delete || permissions.allAccess) && (
                        <button
                          onClick={() => handleDelete(row.inward_id)}
                          className="text-blue-600 hover:text-blue-800"
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      )}

                      {(permissions.pdfDownload || permissions.allAccess) && (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, row)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>

                          <Menu
                            anchorEl={menuAnchorEl}
                            open={
                              Boolean(menuAnchorEl) &&
                              menuRow?.inward_id === row.inward_id
                            }
                            onClose={handleMenuClose}
                          >
                            {settingList && settingList?.find((item) => item.keyName === "inwardCSRF")?.value === "true" ? (
                              <MenuItem
                                onClick={() => {
                                  handleMenuClose();
                                  navigate(`/inwardCSRFPrint/${row.inward_id}`);
                                }}
                              >
                                <PictureAsPdfIcon
                                  fontSize="small"
                                  className="mr-2 text-blue-600"
                                />
                                Test Request Form PDF
                              </MenuItem>
                            ) : (
                              <MenuItem
                                onClick={() => {
                                  handleMenuClose();
                                  navigate(`/inwardPrint/${row.inward_id}`);
                                }}
                              >
                                <PictureAsPdfIcon
                                  fontSize="small"
                                  className="mr-2 text-blue-600"
                                />
                                Test Request Form PDF
                              </MenuItem>
                            )}
                            <MenuItem
                              onClick={() => {
                                handleMenuClose();
                                navigate(`/schedularPrint/${row.inward_id}`);
                              }}
                            >
                              <PictureAsPdfIcon
                                fontSize="small"
                                className="mr-2 text-blue-600"
                              />
                              Testing Schedule
                            </MenuItem>
                          </Menu>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}

              {inwardList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 2}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InwardList;